import { ItemsInicio } from './items-inicio';
import { BannerList } from 'src/app/modals/banner-list';
import { ItemsEcCat } from './items-ec-cat';
export class BanerItemsIncio {
  banner_Prc?: BannerList[];
  banner_Sld?: BannerList[];
  banner_Pub?: BannerList[];
  itemsEC_Destacados?: ItemsInicio[];
  itemsEC_Browse?: ItemsInicio[];
  itemsEcCat?: ItemsEcCat;

  constructor(
    banner_Prc?: BannerList[],
    banner_Sld?: BannerList[],
    banner_Pub?: BannerList[],
    itemsEC_Destacados?: ItemsInicio[],
    itemsEC_Browse?: ItemsInicio[],
    itemsEcCat?: ItemsEcCat,
  ) {
    this.banner_Prc = banner_Prc;
    this.banner_Sld = banner_Sld;
    this.banner_Pub = banner_Pub;
    this.itemsEC_Destacados = itemsEC_Destacados;
    this.itemsEC_Browse = itemsEC_Browse;
    this.itemsEcCat = itemsEcCat;
  }
}
